export const normalizeTransfer = (raw: any) => {
  const t = raw?.transfer ?? raw ?? {}
  return {
    id: String(t.id ?? ''),
    transferNo: t.transferNo ?? t.transfer_no ?? '',
    recipient: t.recipient ?? '',
    amount: Number(t.amount ?? 0),
    description: t.description ?? '',
    status: t.status ?? 'pending',
    transferMode: t.transferMode ?? t.transfer_mode ?? 'REAL_TIME',
    createdAt: t.createdAt ?? t.created_at ?? new Date().toISOString(),
    updatedAt: t.updatedAt ?? t.updated_at ?? new Date().toISOString(),
    wechatTransferId: t.wechatTransferId ?? t.wechat_transfer_id ?? undefined,
    errorMessage: t.errorMessage ?? t.fail_reason ?? undefined,
  }
}

export const normalizeTransfers = (list: any[]) => {
  if (!Array.isArray(list)) return []
  return list.map((t) => ({
    id: String(t.id ?? ''),
    transferNo: t.transferNo ?? t.transfer_no ?? '',
    recipient: t.recipient ?? '',
    amount: Number(t.amount ?? 0),
    description: t.description ?? '',
    status: t.status ?? 'pending',
    transferMode: t.transferMode ?? t.transfer_mode ?? 'REAL_TIME',
    createdAt: t.createdAt ?? t.created_at ?? new Date().toISOString(),
    wechatTransferId: t.wechatTransferId ?? t.wechat_transfer_id ?? undefined,
    errorMessage: t.errorMessage ?? t.fail_reason ?? undefined,
  }))
}
